const normalizeIdentity = (value) => String(value || '').trim().toLowerCase();

export function resolveScheduleRecipient({
  scaledMember = {},
  selectedMembers = [],
  allTeamMembers = [],
  churchMemberById = new Map(),
}) {
  const scaledMemberId = String(scaledMember.id || '');
  const scaledChurchMemberId = String(scaledMember.member_id || '');
  const scaledMemberEmail = normalizeIdentity(scaledMember.member_email);

  let teamMember =
    selectedMembers.find((member) => String(member.id || '') === scaledMemberId) ||
    selectedMembers.find((member) => String(member.member_id || '') === scaledChurchMemberId) ||
    selectedMembers.find((member) => normalizeIdentity(member.email) === scaledMemberEmail) ||
    allTeamMembers.find((member) => String(member.id || '') === scaledMemberId) ||
    allTeamMembers.find((member) => String(member.member_id || '') === scaledChurchMemberId) ||
    allTeamMembers.find((member) => normalizeIdentity(member.email) === scaledMemberEmail) ||
    null;

  const churchMemberId = String(teamMember?.member_id || scaledMember.member_id || '');
  const linkedMember = churchMemberId ? churchMemberById.get(churchMemberId) : null;
  const recipientEmail = normalizeIdentity(teamMember?.email || linkedMember?.email || scaledMember.member_email);
  const recipientMemberId = linkedMember?.id || teamMember?.member_id || scaledMember.member_id || null;

  if (!teamMember && recipientMemberId) {
    teamMember = { member_id: recipientMemberId, email: recipientEmail || null };
  }

  return {
    teamMember,
    recipientEmail,
    recipientMemberId: recipientMemberId || null,
  };
}
